import ApiRequest from '@/plugins/axios'

export default {
  getList () {
    return ApiRequest.get('immoscout')
  },
  preview (objectId) {
    return ApiRequest.get('immoscout/preview/' + objectId)
  },
  synchronize () {
    return ApiRequest.get('immoscout/synchronize')
  }
}
